import { IDefineCommand, IQuery } from 'core-ts-types';
import { ContactInformationModel } from '../models/contact_information_model';

angular
  .module('capability-ng-notification-settings')
  .factory(
    'updatePhoneNumberCommand',
    function updatePhoneNumberCommandDefinition(
      defineCommand: IDefineCommand,
      contactInformationModel: ContactInformationModel,
      $http: ng.IHttpService,
      log: any
    ) {
      return defineCommand(
        'updatePhoneNumberCommand',
        function updatePhoneNumberCommand(deferred: any, number: string) {
          number = contactInformationModel.preparePhoneNumber(number);

          $http
            .post('notification/student/channels/', {
              channel: 'phone',
              target: number
            })
            .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
              deferred.resolve(contactInformationModel.checkResponseNumber(data));
            })
            .catch((error) => {
              if (error.data.detail) {
                window['HIP'].fn.notify({ position: 'top', status: 'warning', message: error.data.detail });
              }
              deferred.reject('failed to load data, please attempt again');
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/commands/update_phone_number_command.ts